export function propagateError(error: any) {
  var errorMessage = error.error;
  if (errorMessage && typeof errorMessage === 'object') {
    const errorMessages: string[] = [];
    for (const key of Object.keys(error.error)) {
      const value = error.error[key];
      if (Array.isArray(value) && value.every(msg => typeof msg === 'string')) {
        // Prefix with the key for clarity, e.g., "EffectiveDate: ..."
        errorMessages.push(...value.map(msg => `${key ? key + ':' : ''} ${msg}`));
      } else if (typeof value === 'string') {
        errorMessages.push(`${value}`);
      }
    }
    throw new Error(errorMessages.length > 0 ? errorMessages.join(', ') : 'An unknown error occurred');
  }
  
  if (errorMessage && typeof errorMessage === 'string') {
    throw new Error(errorMessage);
  } else if (Array.isArray(errorMessage)) {
    throw new Error(errorMessage.join(', '));
  }
}